import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: { flexGrow: 1, flexBasis: 0 },
  scrollView: { marginTop: 33, paddingBottom: 33, paddingHorizontal: 16 },
  title: {
    fontSize: 24,
    ...Fonts.type.bold,
    lineHeight: 33,
    marginBottom: 16,
  },
});
